import { render, staticRenderFns } from "./taskRedListDialog.vue?vue&type=template&id=75bdbfc6&scoped=true"
import script from "./taskRedListDialog.vue?vue&type=script&lang=js"
export * from "./taskRedListDialog.vue?vue&type=script&lang=js"
import style0 from "./taskRedListDialog.vue?vue&type=style&index=0&id=75bdbfc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bdbfc6",
  null
  
)

export default component.exports